module.exports = __webpack_public_path__ + "img/upload-mail.c1643b9a.png";